export default class BaseInstruction {
  constructor(program) {
    this.program = program
  }
}
